export const isLegrandUser = (): boolean => {
  const userJson = localStorage.getItem('user');
  if (userJson) {
    const user = JSON.parse(userJson);
    const email = user.email || '';
    return email.endsWith('@legrand.com') || email.endsWith('@legrand.fr');
  }
  return false;
};